import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { includeBearerTokenInterceptor, provideKeycloak, createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { HttpHandlerFn, HttpRequest, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { responseInterceptor } from './services/response-interceptor.service';

// Configuração do Bearer token interceptor
const urlCondition = createInterceptorCondition({
	urlPattern: new RegExp(`^${environment.api}(/.*)?$`, 'i'),
	bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideKeycloak({
			config: {
				url: environment.keycloak.url,
				realm: environment.keycloak.realm,
				clientId: environment.keycloak.clientId,
			},
			initOptions: {
				onLoad: 'login-required',
				checkLoginIframe: false,
				silentCheckSsoFallback: true,
			},
		}),
		{
			provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
			useValue: [urlCondition],
		},
		provideHttpClient(withInterceptors([includeBearerTokenInterceptor, responseInterceptor])),

		provideBrowserGlobalErrorListeners(),
		provideRouter(routes),
		provideAnimations(),
		provideToastr({
			timeOut: 5000,
			positionClass: 'toast-top-right',
			preventDuplicates: true,
			progressBar: true,
			closeButton: true,
			enableHtml: true,
			toastClass: 'ngx-toastr',
			titleClass: 'toast-title',
			messageClass: 'toast-message',
		}),
		importProvidersFrom(TranslateModule.forRoot()),
	],
};
